import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import { Home, Map, Coffee, ShoppingBag } from 'lucide-react';
import './App.css';

import Entrance from './pages/Entrance';
import Orchard from './pages/Orchard';
import Pavilion from './pages/Pavilion';
import GiftShop from './pages/GiftShop';

function BottomNav() {
  const location = useLocation();
  
  return (
    <nav className="bottom-nav">
      <NavLink to="/" className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
        <Home size={24} />
        <span>Entrance</span>
      </NavLink>
      <NavLink to="/orchard" className={`nav-item ${location.pathname === '/orchard' ? 'active' : ''}`}>
        <Map size={24} />
        <span>Trails</span>
      </NavLink>
      <NavLink to="/pavilion" className={`nav-item ${location.pathname === '/pavilion' ? 'active' : ''}`}>
        <Coffee size={24} />
        <span>Pavilion</span>
      </NavLink>
      <NavLink to="/shop" className={`nav-item ${location.pathname === '/shop' ? 'active' : ''}`}>
        <ShoppingBag size={24} />
        <span>Gift Shop</span>
      </NavLink>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <main className="App-main">
          <Routes>
            <Route path="/" element={<Entrance />} />
            <Route path="/orchard" element={<Orchard />} />
            <Route path="/pavilion" element={<Pavilion />} />
            <Route path="/shop" element={<GiftShop />} />
          </Routes>
        </main>
        <BottomNav />
      </div>
    </Router>
  );
}

export default App;
